import type {
  CurrentUser,
  FinishedAssessment,
  Person,
  PersonInvolvement,
} from "@thalamos/haven-common";
import { guestAskOf } from "@thalamos/haven-common";

import type { FinishedAssessmentRow } from "../../components/AssessmentHistory/AssessmentHistory.js";
import {
  assessorNameOf,
  deciderNameOf,
  finishedAssessmentActions,
} from "./involvementManagement.js";

/**
 * The rows of the assessment history section, in the order the history was
 * read in, each with who it names and what the session is offered on it.
 *
 * The approver named is whoever decided it, not whoever approves the
 * assessor's work now.
 */
export const assessmentHistoryRows = (
  assessments: readonly FinishedAssessment[],
  user: CurrentUser | undefined,
  involvements: PersonInvolvement[] | undefined,
  person?: Person,
  guestsSharedWith: Readonly<Record<string, number>> = {},
): FinishedAssessmentRow[] => {
  const actionsOn = finishedAssessmentActions(user, involvements, person);

  return assessments.map((assessment) => ({
    assessment,
    assessorName: assessorNameOf(assessment, user, involvements),
    approverName:
      assessment.approvedByUserId === null
        ? undefined
        : deciderNameOf(involvements, assessment.approvedByUserId),
    guestAsk: guestAskOf(assessment, involvements),
    // An assessment shared with no guest who can still read it is absent.
    guestsSharedWith: guestsSharedWith[assessment.id] ?? 0,
    actions: actionsOn(assessment),
  }));
};
